module.exports = __webpack_public_path__ + "img/356.5a2369ba.jpg";